import { FlexColumn, FlexResponsive } from '@gorila-shared-ui/components';
import { Block } from 'baseui/block';
import { useBreakpoints } from '../../hooks/useBreakpoints';
import { useStyles } from '../../hooks/useStyles';
import { Device } from '../../types/device';
import Map from '../map/Map';
import CurrentStateAnonymousLocation from '../shared/devices/CurrentStateAnonymousLocation';
import CurrentStateInfo from '../shared/devices/CurrentStateInfo';
import CurrentStateLocation from '../shared/devices/CurrentStateLocation';

type Props = Readonly<{
  device: Device;
}>;

function DeviceCurrentStateWrapper({ device }: Props) {
  const { css } = useStyles();
  const { isSmall } = useBreakpoints();
  const { cs: currentState, asset } = device;
  const isEngineStall = asset?.isEngineStall || false;

  return (
    <FlexColumn>
      {(currentState?.geoReference ||
        !!currentState?.position_latitude ||
        device.hsWithoutAsset?.geoReference ||
        !!device.hsWithoutAsset?.position_latitude) && (
        <Block
          className={css({
            width: '100%',
          })}
        >
          <Map
            fullWindow={false}
            minHeight={isSmall ? '150px' : '250px'}
            minWidth="100%"
          />
        </Block>
      )}
      <FlexResponsive breakAt="extraLarge">
        <CurrentStateInfo
          currentState={{
            geoReference: currentState?.geoReference || device.hsWithoutAsset?.geoReference,
            position_latitude: currentState?.position_latitude || device.hsWithoutAsset?.position_latitude,
            position_longitude: currentState?.position_longitude || device.hsWithoutAsset?.position_longitude,
            timestamp: currentState?.timestamp || device.hsWithoutAsset?.timestamp,
            ident: currentState?.ident || device.hsWithoutAsset?.ident,
            position_speed: currentState?.position_speed || device.hsWithoutAsset?.position_speed,
            deviceModel: currentState?.deviceModel || device.hsWithoutAsset?.deviceModel,
            notificationType: currentState?.notificationType || device.hsWithoutAsset?.notificationType,
            engine_ignition_status:
              currentState?.engine_ignition_status || device.hsWithoutAsset?.engine_ignition_status,
            battery_percentage: currentState?.battery_percentage || device.hsWithoutAsset?.battery_percentage,
            external_powersource_voltage:
              currentState?.external_powersource_voltage || device.hsWithoutAsset?.external_powersource_voltage,
            backup_battery_voltage:
              currentState?.backup_battery_voltage || device.hsWithoutAsset?.backup_battery_voltage,
          }}
          isEngineStall={isEngineStall}
        />
        <CurrentStateLocation currentState={currentState} />
        <CurrentStateAnonymousLocation device={device} />
      </FlexResponsive>
    </FlexColumn>
  );
}

export default DeviceCurrentStateWrapper;
